import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moneyFormat',
  standalone: true

})
export class MoneyFormatPipe implements PipeTransform {

  transform(value: number | string | null | undefined, locale: string = 'en-US'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    return Math.round(num).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, ' ');
  }
}